exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VisibilitySettings-module__visibility-settings-popup___3I7WK{display:flex;flex-direction:column;gap:1rem}.VisibilitySettings-module__visibility-settings-popup___3I7WK p{width:100%;text-align:left}.VisibilitySettings-module__visibility-settings-popup___3I7WK p:first-child{font-weight:700}", ""]);

// exports
exports.locals = {
	"visibility-settings-popup": "VisibilitySettings-module__visibility-settings-popup___3I7WK"
};